// extracted by mini-css-extract-plugin
export default {"slideContainer":"_650986878d _593c2dc211 cecd743e25","slideImage":"f911ffe632"};